import { envvar, envvarOrDefault } from "@cartographerio/util";

export const mapboxAccessToken: string = envvar(
  "REACT_APP_GL_MAPBOX_ACCESS_TOKEN"
);

export const defaultCartographerApiUrl: string = envvarOrDefault(
  "REACT_APP_GL_CARTOGRAPHER_API_URL",
  "https://api.cartographer.io"
);

export const gpsPrecision: number = 6;
export const ngrPrecision: number = 5;
